import styled from '@emotion/styled';
import { RatingsAndReviewsSummary } from '@kyruus/provider-components';

export const RatingsAndReviewsHeader = styled(RatingsAndReviewsSummary)`
  margin: 0;
`;
